import React, { useState, useEffect } from "react";
import SiteWrapper from "../../../SiteWrapper.react";
import { LoadingScreen } from "../../../components/LoadingScreen";
import DashboardMaerskAPI from "./DashboardMaerskAPI";

const ReportesApi = () => {
    //Variables check loading y error
    const [loading, setLoading] = useState([]);


    return (
        <SiteWrapper>
            <div className="container" style={{"margin":"2rem auto"}}>
                <DashboardMaerskAPI/>
                {/* {loading ? <LoadingScreen loading={loading} /> : null} */}
            </div>
        </SiteWrapper>
    );
};

export default ReportesApi;
